import type { DetailedHTMLProps, InputHTMLAttributes, Ref } from 'react';

import { IconSystem } from '#icons/IconSystem';

import styles from './SearchInput.module.scss';

type Props = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & { onClear?: () => void } & {
	ref?: Ref<HTMLInputElement | null>;
};

export function SearchInput({ ref, onClear, ...inputProps }: Props) {
	return (
		<div className={styles.wrapper}>
			<input
				className={`${styles.input} body5`}
				aria-label="Suchbegriff eingeben"
				placeholder="Suchbegriff eingeben"
				ref={ref}
				type="text"
				{...inputProps}
			/>

			<button className={styles.close} onClick={onClear}>
				<IconSystem icon="close" variant="filled" title="Suche zurücksetzen" />
			</button>
		</div>
	);
}
